import React from 'react';
import QueryStatsRoundedIcon from '@mui/icons-material/QueryStatsRounded';
import {
  Box,
  Button,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Typography,
} from '@mui/material';
import { PeriodoFiltro } from '../IndicadoresGraficos.loaders';
import { useNavigate } from 'react-router-dom';
import './IndicadoresHeaderFiltros.css';

type IndicadoresHeaderFiltrosProps = {
  periodoFiltro: PeriodoFiltro;
  onPeriodoChange: (valor: PeriodoFiltro) => void;
  mostrarFiltroAgente?: boolean;
  agenteFiltro?: string;
  agentesOptions?: Array<{ id: string; nome: string }>;
  onAgenteChange?: (valor: string) => void;
  kpiResumo?: React.ReactNode;
};

function IndicadoresHeaderFiltros({
  periodoFiltro,
  onPeriodoChange,
  mostrarFiltroAgente = false,
  agenteFiltro = '',
  agentesOptions = [],
  onAgenteChange,
  kpiResumo,
}: IndicadoresHeaderFiltrosProps) {
  const navigate = useNavigate();

  const novoPedido = () => {
    navigate("/mvp", {
      state: {
        propsPage: "novoPedido"
      }
    })
  };

  const novoAgente = () => {
    navigate("/mvp", {
      state: {
        propsPage: "cadAgente"
      }
    })
  }

  return (
    <Paper elevation={0} className='indicadores-paper-header'>
      <Box className='indicadores-header-top'>
        <Box className='indicadores-title-wrap'>
          <Box className='indicadores-title-icon'>
            <QueryStatsRoundedIcon />
          </Box>
          <Box>
            <Box className='indicadores-title-line'>
              <Typography variant='h6' className='indicadores-title'>
                Visão Geral
              </Typography>
            </Box>
            <Typography className='indicadores-subtitle'>
              Acompanhe volume, faturamento e itens mais vendidos no período selecionado.
            </Typography>                  
          </Box>          
          
        </Box>
        <Divider className='indicadores-divider' />
        
      </Box>

      <Box className='indicadores-filtros-row'>
        <Box className='indicadores-filtro-periodo-box'>
          <Box className='indicadores-linha-selects'>
            <FormControl size='small' className='indicadores-form-control indicadores-form-control-periodo'>
              <InputLabel id='periodo-select-label' shrink>Período</InputLabel>
              <Select
                labelId='periodo-select-label'
                value={periodoFiltro}
                label='Período'
                onChange={(e) => onPeriodoChange(e.target.value as PeriodoFiltro)}
                className='indicadores-select'
              >
                <MenuItem value='ultima_semana' className='indicadores-menu-item'>Última semana</MenuItem>
                <MenuItem value='ultimo_mes' className='indicadores-menu-item'>Último mês</MenuItem>
                <MenuItem value='ultimos_3_meses' className='indicadores-menu-item'>Últimos 3 meses</MenuItem>
                <MenuItem value='ultimos_6_meses' className='indicadores-menu-item'>Últimos 6 meses</MenuItem>
                <MenuItem value='ultimos_12_meses' className='indicadores-menu-item'>Últimos 12 meses</MenuItem>
              </Select>
            </FormControl>

            {mostrarFiltroAgente && onAgenteChange ? (
              <FormControl size='small' className='indicadores-form-control'>
                <InputLabel id='agente-select-label' shrink>Representante</InputLabel>
                <Select
                  labelId='agente-select-label'
                  value={agenteFiltro}
                  label='Representante'
                  displayEmpty
                  onChange={(e) => onAgenteChange(e.target.value as string)}
                  className='indicadores-select'
                >
                  <MenuItem value='' className='indicadores-menu-item'>Todos representantes</MenuItem>
                  {agentesOptions.map((agente) => (
                    <MenuItem key={agente.id} value={agente.id} className='indicadores-menu-item'>
                      {agente.nome}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : null}
           
          </Box>
        </Box>
        <Box className='indicadores-header-acoes'>
            <Button
              className='indicadores-btn-novo-pedido'
              variant='contained'
              onClick={novoPedido}
            >
              + pedido
            </Button>

            <Button
              className='indicadores-btn-novo-agente'
              variant='contained'
              onClick={novoAgente}
            >
              + agente
            </Button>
          </Box>

        {kpiResumo ? (
          <Box className='indicadores-filtros-kpi-inline'>
            {kpiResumo}
          </Box>
        ) : null}

      </Box>
    </Paper>
  );
}

export default IndicadoresHeaderFiltros;
